<template>
	<div class="polaroid-view" :class="{ darken }" @click="dismiss">
		<div class="polaroid-view__polaroid" @click.stop>
			<SubmissionPolaroid
				:submission="submission"
				:wall="wall"
				view-only
				@vote="dismiss"
			/>
		</div>
		<div class="polaroid-view__instructions">
			<p>Drag left or right to dismiss</p>
		</div>
	</div>
</template>

<script>
import SubmissionPolaroid from '@/components/main/SubmissionPolaroid'

export default {
	name: 'PolaroidView',
	props: {
		submission: Object,
		darken: {
			type: Boolean,
			default: false
		},
		wall: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		dismiss() {
			this.$emit('dismiss')
		}
	},
	components: {
		SubmissionPolaroid
	}
}
</script>

<style lang="scss" scoped>
@use "sass:math";
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/mq';

$caption-max: 576px;

.polaroid-view {
	@extend %abs-full;
	@extend %flex-center;
	position: fixed;
	flex-direction: column;

	&.darken {
		background-color: rgba($black, 0.75);
	}

	&__polaroid {
		position: relative;
		flex-grow: 1;
		margin-bottom: 12vh;
	}

	&__instructions {
		position: absolute;
		top: calc(50% + 50vw);
		left: 0;
		width: 100%;

		p {
			margin: 0;
			text-align: center;
			font-weight: bold;
			color: $white;
		}
	}

	@include mq(xs) {
		&__instructions p {
			font-size: 1.125rem;
		}
	}

	@media (min-width: $caption-max) {
		&__instructions {
			top: calc(50% + #{math.div($caption-max, 2)});
		}
	}

	@include mq(md) {
		&__instructions p {
			font-size: 1.25rem;
		}
	}
}
</style>
